/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import shakingHands from "../../assets/icons/employment/IconAgreement";

const linkedCardsHomePage= [
  {
    icon: shakingHands,
    heading: "Abfindung",
    subHeading: "Professionell und schnell gegen Ihre Kündigung angehen",
    link: "/servicewelt",
  },
];

export default linkedCardsHomePage;
